var PROJ = (typeof PROJ === 'object') ? PROJ : {};

PROJ.shopRoot = PROJ.shopRoot || function () {
    if (window.Shopify && Shopify.routes && typeof Shopify.routes.root === 'string') {
        return Shopify.routes.root;
    }
    if (window.Theme && Theme.routes && Theme.routes.cart_url) {
        return String(Theme.routes.cart_url).replace(/\/cart\/?$/, '/');
    }
    return '/';
};

PROJ.cartUrl = PROJ.cartUrl || function (path) {
    var root = PROJ.shopRoot();
    if (root.slice(-1) !== '/') root += '/';
    return root + String(path || '').replace(/^\//, '');
};

var shipPs = "spc1";
var shipLocalPrice;
document.addEventListener('DOMContentLoaded', function() {
    PROJ.ajaxcart.init();
});



PROJ.ajaxcart = {
    VAR: {
        fetchMiniCartTimer: null
    },

    debug: function () {
        try {
            return (
                window.location.search.indexOf('debug_minicart=1') >= 0 ||
                window.localStorage.getItem('debug_minicart') === '1'
            );
        } catch (e) {
            return false;
        }
    },

    log: function () {
        if (!this.debug() || !window.console) return;
        try {
            // eslint-disable-next-line no-console
            console.log.apply(console, ['[minicart]'].concat([].slice.call(arguments)));
        } catch (e) {}
    },

    init: function () {
        var _this = this;
        _this.VAR.addAndCheckoutInProgress = false;

        var walletElement = document.querySelector('[wallet-configs]');
        if (walletElement) {
            var quickpay = JSON.parse(walletElement.getAttribute('wallet-configs'));
            var miniCart = document.getElementById('mini-cart');
            if (miniCart && Array.isArray(quickpay)) {
                for (var s = 0; s < quickpay.length; s++) {
                    miniCart.classList.add(quickpay[s].name);
                }
            }
        }

        // Remove protection product from cart when cart loads if sp is enabled and product is in cart, without reloading mini-cart
        if (typeof shipProtEnabled !== 'undefined' && shipProtEnabled && typeof shipProtectionIds !== 'undefined' && shipProtectionIds) {
            var spIds = shipProtectionIds.split(",").filter(Boolean);
            if (spIds.length > 0) {
                var removeStr = spIds.map(function(id) {
                    return "updates[" + id + "]=0";
                }).join("&");
                if (removeStr) {
                    fetch(PROJ.cartUrl('cart/update.js'), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: removeStr
                    })
                    .then(function(response) {
                        if (!response.ok) throw new Error('Network response was not ok');
                        return response.json();
                    })
                    .then(() => {
                        _this.updatePriceCart();
                    })
                    .catch(() => {
                        _this.updatePriceCart();
                    });
                }
            }
        }

        setTimeout(function(){
            _this.reloadOfferbar();
            _this.animateCart();
            _this.syncFreeGifts();
            _this.initCountdown();
        },100);

        //auto open minicart
        if (window.location.href.includes("minicart=true")) {
            document.documentElement.classList.add('mini-cart');
            document.body.classList.add('mini-cart');

            setTimeout(() => {
                document.documentElement.classList.add('mini-cart-ani');
                document.body.classList.add('mini-cart-ani');
            }, 500);
        }



        ['click'].forEach(eventType => {
            document.body.addEventListener(eventType, function(e) {
                let clicked = e.target;
                if (e.target.closest('a.mini_cart, .opencart')) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this.opencart();
                } else {
                    var cartAnchor = e.target.closest('a[href]');
                    if (cartAnchor) {
                        var cartHref = (cartAnchor.getAttribute('href') || '').split('?')[0];
                        if (/\/cart\/?$/.test(cartHref)) {
                            e.preventDefault();
                            e.stopPropagation();
                            _this.opencart();
                        }
                    }
                }
                if (e.target.closest('.nav-close-cart, .minicart-back')) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this.closecart();
                }
                //remove from cart
                if (e.target.classList.contains('remove') && e.target.closest('.incart')) {
                    e.preventDefault();
                    let par = e.target.closest('.incart');
                    let qty = 0;
                    _this.updateItem(par.getAttribute('data-proid'), qty);
                }

                //Hide Complet the set
                if (e.target.classList.contains('hide-cts')) {
                    e.preventDefault();
                    document.body.classList.add('hide-cts-cart');
                }
                if (clicked.classList.contains('qty-step-btn')) {
                    e.preventDefault();
                    let input = clicked.closest('.mcart-item').querySelector('.qty-input');
                    if (input) {
                        let currentValue = parseInt(input.value, 10) || 0;

                        if (clicked.classList.contains('plus')) {
                            input.value = currentValue + 1;
                        } else if (clicked.classList.contains('minus') && currentValue > 0) {
                            input.value = currentValue - 1;
                        }

                        _this.updateItem(input.getAttribute('data-proid'), input.value);
                    }
                }
                if (clicked.getAttribute('data-directadd')) {
                    e.preventDefault();
                    var vid = clicked.getAttribute('data-directadd');
                    _this.log('directadd click', vid);
                    _this.addItem(vid)
                        .then(function () {
                            _this.log('directadd addItem resolved -> open');
                            _this.opencart();
                        })
                        .catch(function (err) {
                            _this.log('directadd addItem error', err);
                        });
                }
                // Add item and go to checkout
                if (clicked.getAttribute('data-add-and-checkout') || clicked.closest('[data-add-and-checkout]')) {
                    e.preventDefault();
                    e.stopPropagation();
                    const addAndCheckoutElement = clicked.closest('[data-add-and-checkout]') || clicked;
                    if (_this.VAR.addAndCheckoutInProgress || addAndCheckoutElement.classList.contains('is-processing')) {
                        return;
                    }
                    const variantId = addAndCheckoutElement.getAttribute('data-add-and-checkout');
                    const spProductId = addAndCheckoutElement.getAttribute('data-sp-product-id');
                    if (variantId) {
                        var proceedAddAndCheckout = function () {
                            _this.VAR.addAndCheckoutInProgress = true;
                            addAndCheckoutElement.classList.add('is-processing');
                            addAndCheckoutElement.setAttribute('aria-disabled', 'true');
                            addAndCheckoutElement.setAttribute('tabindex', '-1');
                            addAndCheckoutElement.style.pointerEvents = 'none';
                            _this.addItemAndCheckout(variantId, spProductId, addAndCheckoutElement);
                        };
                        var miniRoot = document.getElementById('mini-cart');
                        if (
                            typeof PROJ !== 'undefined' &&
                            PROJ.ageVerification &&
                            PROJ.ageVerification.hasMinicartDeclaration &&
                            PROJ.ageVerification.hasMinicartDeclaration()
                        ) {
                            if (!PROJ.ageVerification.isMinicartConsentChecked()) {
                                var ageBox = PROJ.ageVerification.getMinicartCheckbox();
                                if (ageBox) {
                                    ageBox.focus();
                                }
                                return;
                            }
                            proceedAddAndCheckout();
                            return;
                        }
                        if (
                            typeof PROJ !== 'undefined' &&
                            PROJ.ageVerification &&
                            typeof PROJ.ageVerification.ensureConsentIfCartRestricted === 'function' &&
                            PROJ.ageVerification.cartDomNeedsAgeCheck(miniRoot || document)
                        ) {
                            PROJ.ageVerification.ensureConsent().then(function (ok) {
                                if (ok) {
                                    proceedAddAndCheckout();
                                }
                            });
                            return;
                        }
                        proceedAddAndCheckout();
                    }
                }

                let isProcessing = false;

                if (clicked.closest("[data-protection-id]")) {
                    if (isProcessing) return; // stop second run
                    isProcessing = true;
                    setTimeout(() => isProcessing = false, 1000); // reset after 300ms

                    const clickedPro = clicked.closest("[data-protection-id]");
                    e.preventDefault();
                    const protectionId = clickedPro.getAttribute("data-protection-id");

                    if (clickedPro.classList.contains("active")) {
                        // Remove protection
                        (document.querySelector("[data-sp-update]")?.removeAttribute("data-sp-update"));
                        sessionStorage.setItem(shipPs, "false");
                        clickedPro.classList.remove("active");
                        _this.updateItem(protectionId, 0);
                    } else {
                        // Add protection manually
                        sessionStorage.setItem(shipPs, "true");
                        clickedPro.classList.add("active");
                        _this.addItem(protectionId);
                    }
                }

                if (clicked.classList.contains('swap-gift-wrap')) {
                    e.preventDefault();
                    document.querySelector('.gift-wrap-box')?.classList.toggle('active');
                }
                // Order note: open inline form
                if (clicked.closest('.order-note-toggle')) {
                    e.preventDefault();
                    var block = clicked.closest('.order-note-block');
                    if (block) {
                        block.querySelector('.order-note-toggle').style.display = 'none';
                        block.querySelector('.order-note-inline').style.display = 'block';
                    }
                }
                // Order note: save and refresh cart
                if (clicked.classList.contains('order-note-save')) {
                    e.preventDefault();
                    var block = clicked.closest('.order-note-block');
                    if (block) {
                        var textarea = block.querySelector('.order-note-textarea');
                        var note = textarea ? textarea.value : '';
                        _this.cartRequest(PROJ.cartUrl('cart/update.js'), { note: note });
                    }
                }
                // Order note: cancel and hide form
                if (clicked.classList.contains('order-note-cancel')) {
                    e.preventDefault();
                    var block = clicked.closest('.order-note-block');
                    if (block) {
                        block.querySelector('.order-note-inline').style.display = 'none';
                        block.querySelector('.order-note-toggle').style.display = '';
                    }
                }
                // Close shipping protection info (check this first to prevent toggle)
                if (clicked.classList.contains('csp-close') || clicked.closest('.csp-close')) {
                    e.preventDefault();
                    e.stopPropagation();
                    const infoBox = clicked.closest('.csp-more');
                    if (infoBox) {
                        infoBox.classList.remove('active');
                    }
                    return;
                }
                // Toggle shipping protection info (click anywhere on summary)
                const summaryDiv = clicked.closest('.shipping-protection-summary');
                if (summaryDiv) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (summaryDiv.nextElementSibling && summaryDiv.nextElementSibling.classList.contains('csp-more')) {
                        summaryDiv.nextElementSibling.classList.toggle('active');
                    }
                    return;
                }
                // pay buttons
                if (clicked.classList.contains('openpays')) {
                    e.preventDefault();
                    e.stopPropagation();
                    document.querySelector('#mini-cart')?.classList.toggle('quickpay');
                }
                //gift wrap
                if (clicked.closest("[ data-gift-wrap-id]"))
                    {
                        const clickedPro = clicked.closest("[data-gift-wrap-id]");
                        e.preventDefault();
                        const protectionId = clickedPro.getAttribute("data-gift-wrap-id");
                        if (clickedPro.classList.contains("active")) {
                            _this.updateItem(protectionId, 0);
                        } else {
                            // _this.addItem(protectionId);
                            document.querySelector('.gift-wrap-box').classList.add('active');
                        }
                    }
                    if (clicked.closest("[data-gift-wrap-change]"))
                    {
                        const clickedPro = clicked.closest("[data-gift-wrap-change]");
                        e.preventDefault();
                        const protectionId = clickedPro.getAttribute("data-gift-wrap-change");
                        if (clickedPro.classList.contains("active")) {
                            const giftWrapMessage = document.querySelector('.gift-wrap-message')?.value?.trim();
                            const cartData = {
                                id: protectionId,
                                quantity: 1
                            };

                            if (giftWrapMessage) {
                                cartData.properties = {
                                    Message: giftWrapMessage
                                };
                            } else {
                                cartData.properties = {
                                    Message:null
                                };
                            }

                            _this.cartRequest(PROJ.cartUrl('cart/change.js'), cartData);
                        } else {
                            const giftWrapMessage = document.querySelector('.gift-wrap-message')?.value?.trim();
                            const cartData = {
                                id: protectionId,
                                quantity: 1
                            };

                            if (giftWrapMessage) {
                                cartData.properties = {
                                    Message: giftWrapMessage
                                };
                            } else {
                                cartData.properties = {
                                    Message: ""
                                };
                            }

                            _this.cartRequest(PROJ.cartUrl('cart/add.js'), cartData);
                        }
                    }




            });
        });

        document.body.addEventListener('change', function (e) {
            let input = e.target;
            //change input in minicart items
            if (input.matches('.mcart-item [data-proid].qty-input')) {
                e.preventDefault();
                _this.updateItem(input.getAttribute('data-proid'), input.value);
            }

            if (input.matches(`[data-select-add]`)) {
                e.preventDefault();
                let variantId = input.value;
                if (!variantId) return;

                _this.log('select-add change', variantId);
                _this.cartRequest(PROJ.cartUrl('cart/add.js'), { id: variantId, quantity: 1 })
                    .then(function () {
                        _this.log('select-add resolved -> open');
                        _this.opencart();
                    })
                    .catch(function (err) {
                        _this.log('select-add error', err);
                    });
            }
        });

        // Character counter for gift wrap message
        document.body.addEventListener('input', function(e) {
            if (e.target.classList.contains('gift-wrap-message')) {
                var textarea = e.target;
                var counter = textarea.closest('.gift-wrap-box')?.querySelector('.gift-wrap-counter');
                if (counter) {
                    var len = textarea.value.length;
                    var max = textarea.getAttribute('maxlength') || 200;
                    counter.textContent = len + '/' + max + ' characters';
                }
            }
        });


    },
    opencart: function () {
        var _this = this;

        document.querySelectorAll('body,html').forEach(item => {
            item.classList.add('mini-cart');
            setTimeout(function(){
                item.classList.add('mini-cart-ani');
            },500);
        });

        setTimeout(function () {
            _this.animateCart();
            _this.syncFreeGifts();
        }, 150);
    },
    closecart: function () {

        document.querySelectorAll('body,html').forEach(item => {
            item.classList.remove('mini-cart');
            setTimeout(function(){
                item.classList.remove('mini-cart-ani');
            },500);
        });

    },
    updateCart: function () {
        document.getElementById('mini-cart').classList.add('loading');
        return this.fetchMiniCartHtml();
    },

    cartRequest: function (url, body) {
        var _this = this;
        document.getElementById('mini-cart').classList.add('loading');
        _this.VAR.skipGiftSync = true;
        return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
        })
            .then(function (response) {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(function () {
                return _this.fetchMiniCartHtml();
            })
            .catch(function () {
                return _this.fetchMiniCartHtml();
            });
    },

    parseMiniCartHtml: function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html.trim();
        return temp.querySelector('#shopify-section-mini-cart')
            || temp.querySelector('.mini-cart')
            || temp;
    },

    fetchMiniCartHtml: function () {
        var _this = this;
        clearTimeout(_this.VAR.fetchMiniCartTimer);
        return new Promise(function (resolve, reject) {
            _this.VAR.fetchMiniCartTimer = setTimeout(function () {
                _this.fetchMiniCartHtmlNow().then(resolve).catch(reject);
            }, 80);
        });
    },

    fetchMiniCartHtmlNow: function () {
        var _this = this;
        return fetch(PROJ.cartUrl('cart?view=mini'), { credentials: 'same-origin' })
            .then(function (response) {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text();
            })
            .then(function (html) {
                _this.syncMiniCartFromHtml(html);
            })
            .catch(function (error) {
                var miniCart = document.getElementById('mini-cart');
                if (miniCart) miniCart.classList.remove('loading');
                _this.VAR.skipGiftSync = false;
                _this.VAR.giftSyncInProgress = false;
                console.error('Error fetching mini cart:', error);
            });
    },

    syncMiniCartFromHtml: function (html) {
        var _this = this;
        var sourceRoot = _this.parseMiniCartHtml(html);
        var miniCart = document.getElementById('mini-cart');
        var place = miniCart && miniCart.querySelector('.ajax_place');
        var currentForm = miniCart && miniCart.querySelector('.minicart-form');

        if (!place || !currentForm) {
            if (place) {
                place.innerHTML = sourceRoot.innerHTML || html;
            }
            _this.afterMiniCartSync();
            return;
        }

        var regions = ['.c-scroll-section', '.ns-bottom', '.ns-top.mc-ajax'];
        var syncedAny = false;
        regions.forEach(function (selector) {
            var newEl = sourceRoot.querySelector(selector);
            var curEl = miniCart.querySelector(selector);
            if (newEl && curEl) {
                curEl.replaceWith(newEl.cloneNode(true));
                syncedAny = true;
            }
        });

        if (!syncedAny) {
            place.innerHTML = sourceRoot.innerHTML || html;
            _this.afterMiniCartSync();
            return;
        }

        var newForm = sourceRoot.querySelector('.minicart-form');
        var syncedForm = miniCart.querySelector('.minicart-form');
        if (newForm && syncedForm) {
            ['data-icount', 'data-ctry', 'data-total', 'data-age-restricted', 'data-age-confirmed'].forEach(function (attr) {
                if (newForm.hasAttribute(attr)) {
                    syncedForm.setAttribute(attr, newForm.getAttribute(attr) || '');
                } else {
                    syncedForm.removeAttribute(attr);
                }
            });
        }

        if (miniCart && newForm) {
            if (newForm.getAttribute('data-age-restricted') === 'true') {
                miniCart.setAttribute('data-age-restricted', 'true');
            } else {
                miniCart.removeAttribute('data-age-restricted');
            }
            var dyn = miniCart.querySelector('.dynamic-checkout-buttons');
            if (dyn) {
                dyn.hidden = newForm.getAttribute('data-age-restricted') === 'true';
            }
        }

        var scriptEl = sourceRoot.querySelector('script');
        if (scriptEl && scriptEl.textContent) {
            var idsMatch = scriptEl.textContent.match(/var shipProtectionIds = "([^"]*)"/);
            if (idsMatch) {
                shipProtectionIds = idsMatch[1];
            }
        }

        _this.afterMiniCartSync();
    },

    afterMiniCartSync: function () {
        var _this = this;
        document.getElementById('mini-cart').classList.remove('loading');
        _this.VAR.skipGiftSync = false;
        _this.VAR.giftSyncInProgress = false;

        var countElement = document.querySelector('#mini-cart [data-icount]');
        var counti = countElement ? countElement.getAttribute('data-icount') : null;
        var cartBubble = document.querySelector('.cart-count-bubble');
        if (counti && cartBubble) {
            cartBubble.textContent = counti;
        }

        _this.moveGiftTargets();
        _this.reloadOfferbar();
        _this.animateCart();
        _this.initCountdown();
        if (typeof PROJ !== 'undefined' && PROJ.ageVerification && typeof PROJ.ageVerification.syncMinicartCheckoutState === 'function') {
            PROJ.ageVerification.syncMinicartCheckoutState();
        }
        setTimeout(function () {
            _this.syncFreeGifts();
        }, 0);
    },

    moveGiftTargets: function () {
        var root = document.getElementById('mini-cart');
        if (!root) return;
        var giftsWrap = root.querySelector('.target-gifts');
        if (!giftsWrap) return;
        root.querySelectorAll('.ns-target-gift').forEach(function (element) {
            if (element.parentElement !== giftsWrap) {
                giftsWrap.appendChild(element);
            }
        });
    },

    getCartProgressCents: function () {
        var root = document.getElementById('mini-cart');
        if (!root) return 0;
        var form = root.querySelector('.minicart-form');
        if (form && form.dataset.total !== undefined && form.dataset.total !== '') {
            return Number(form.dataset.total) || 0;
        }
        var progressEl = root.querySelector('.ns-progress');
        return Number(progressEl && progressEl.dataset.progress) || 0;
    },

    findGiftLineInCart: function (cart, productId, variantId) {
        if (!cart || !cart.items) return null;
        var found = null;
        cart.items.forEach(function (item) {
            if (productId && String(item.product_id) === String(productId)) {
                found = item;
            } else if (variantId && String(item.variant_id) === String(variantId)) {
                found = item;
            }
        });
        return found;
    },

    syncFreeGifts: function () {
        var _this = this;
        var root = document.getElementById('mini-cart');

        if (!root || _this.VAR.skipGiftSync || _this.VAR.giftSyncInProgress) {
            return Promise.resolve();
        }

        _this.moveGiftTargets();

        var gifts = root.querySelectorAll('.ns-target-gift.noappgift:not(.manualgift)');
        if (!gifts.length) {
            return Promise.resolve();
        }

        var progress = _this.getCartProgressCents();

        return fetch(PROJ.cartUrl('cart.js'), { credentials: 'same-origin' })
            .then(function (response) {
                if (!response.ok) throw new Error('cart.js failed');
                return response.json();
            })
            .then(function (cart) {
                if (_this.VAR.skipGiftSync || _this.VAR.giftSyncInProgress) {
                    return;
                }

                for (var i = 0; i < gifts.length; i++) {
                    var el = gifts[i];
                    var threshold = Number(el.getAttribute('data-gift-target') || 0);
                    var variantId = el.getAttribute('data-gift-variant-id');
                    var productId = el.getAttribute('data-gift-product-id');
                    var lineItem = _this.findGiftLineInCart(cart, productId, variantId);
                    var inCart = !!lineItem;

                    if (progress >= threshold && !inCart && variantId) {
                        _this.VAR.giftSyncInProgress = true;
                        _this.addItem(variantId);
                        return;
                    }

                    if (progress < threshold && inCart && lineItem) {
                        _this.VAR.giftSyncInProgress = true;
                        _this.updateItem(lineItem.key, 0);
                        return;
                    }

                    if (inCart && lineItem && lineItem.quantity > 1) {
                        _this.VAR.giftSyncInProgress = true;
                        _this.updateItem(lineItem.key, 1);
                        return;
                    }
                }
            })
            .catch(function (err) {
                console.error('syncFreeGifts:', err);
            });
    },

    animateCart: function () {
        // to update and animate mini cart with total price
        var _this = this;

        _this.moveGiftTargets();

        var root = document.getElementById('mini-cart');
        if (!root) return;

        var locks = root.querySelectorAll('.target-locks .target');
        var rate = Number(window.market_exchange_rate ?? 1) || 1;
        var progress = _this.getCartProgressCents();
        var gifts = root.querySelectorAll('.ns-target-gift');

        var current_target;
        var next_target;
        var gapToNext = 0;
        var gapToNextText = "";
        // change lock prices (display uses market rate; thresholds compare shop cents)
        locks.forEach((target, i) => {
            const targetValue = Number(target.getAttribute('data-target') || 0);
            const targetAmmountRound = Math.round((targetValue * rate) / 100);

            if (targetValue > 0) {
                const mclockPriceElem = target.querySelector('.mclock-price');
                if (mclockPriceElem) {
                    mclockPriceElem.textContent = targetAmmountRound;

                    if (progress < targetValue && gapToNext <= 0) {
                        current_target = target;
                        next_target = locks[i + 1];
                        gapToNext = targetValue - progress;
                        gapToNextText = target.getAttribute('data-text');
                    }
                }
            }
        });

        // update cart quantity bar
        var mCartPromo = root.querySelector('.mc-promo-dynamic');
        if (gapToNext > 0) {
            var gapValue = (gapToNext / 100).toFixed(0);
            if (mCartPromo) {
                mCartPromo.innerHTML = "You are <b>" + market_symbol + gapValue + "</b> away from your <b>" + gapToNextText + "</b>";
            }
        } else {
            if (mCartPromo) mCartPromo.innerHTML = "";
        }

        gifts.forEach(function (target) {
            const threshold = Number(target.getAttribute('data-gift-target') || 0);
            const gapCents = threshold - progress;
            const gapDisplay = (gapCents / 100).toFixed(2);

            const mclockPriceElem = target.querySelector('.giftgap');
            if (mclockPriceElem) mclockPriceElem.textContent = market_symbol + gapDisplay;

            target.classList.remove('mc-notmet-p', 'mc-toadd-p');
            if (progress >= threshold) {
                target.classList.add('mc-toadd-p');
            } else {
                target.classList.add('mc-notmet-p');
            }

        });

        if (locks.length < 2) {
            return;
        }

        var gap = 100 / (locks.length - 1);
        var barCurrent = null;
        var barNext = null;

        locks.forEach((target, i) => {
            const targetValue = Number(target.getAttribute('data-target') || 0);
            if (targetValue > 0 && progress >= targetValue) {
                barCurrent = target;
                barNext = locks[i + 1];

                setTimeout(function() {
                    target.classList.add("active");
                }, 300 * i);
            }
        });

        setTimeout(function () {
            var fill = root.querySelector('.ns-progress-fill');
            if (!fill) return;

            var lastRealTargetValue = 0;
            locks.forEach(function (target) {
                var targetValue = Number(target.getAttribute('data-target') || 0);
                if (targetValue > 0 && target.querySelector('.mclock-price')) {
                    lastRealTargetValue = targetValue;
                }
            });

            var barwidth;
            if (lastRealTargetValue > 0 && progress >= lastRealTargetValue) {
                barwidth = 100;
            } else if (barNext && barCurrent) {
                const currentTargetValue = Number(barCurrent.getAttribute('data-target') || 0);
                const nextTargetValue = Number(barNext.getAttribute('data-target') || 0);
                const extraval = nextTargetValue > currentTargetValue
                    ? (progress - currentTargetValue) / (nextTargetValue - currentTargetValue)
                    : 0;
                barwidth = (Array.from(locks).indexOf(barCurrent) * gap) + (gap * extraval);
            } else if (progress <= 0) {
                barwidth = 0;
            } else {
                var firstReal = null;
                var firstVal = 0;
                locks.forEach(function (target) {
                    var targetValue = Number(target.getAttribute('data-target') || 0);
                    if (!firstReal && targetValue > 0 && target.querySelector('.mclock-price')) {
                        firstReal = target;
                        firstVal = targetValue;
                    }
                });
                if (firstReal && firstVal > 0 && progress < firstVal) {
                    barwidth = gap * (progress / firstVal);
                } else {
                    barwidth = 100;
                }
            }

            fill.style.width = Math.min(100, Math.max(0, barwidth)) + '%';
        }, 100);


    },  reloadOfferbar:function () {
        var rate = typeof market_exchange_rate !== 'undefined' ? market_exchange_rate : 1;
        var root = document.getElementById('mini-cart');
        if (!root) return;
        var targets = root.querySelectorAll('[data-target]');

        targets.forEach(function(target) {
            var val = target.getAttribute('data-target');
            if (target.querySelector('sp')) {
                target.querySelector('sp').textContent = Math.round(val * rate / 100);
            }
        });
    },

    updatePriceCart: function () {
        return this.fetchMiniCartHtml();
    },

    updateItem: function (id, le) {
        return this.cartRequest(PROJ.cartUrl('cart/change.js'), { id: id, quantity: le });
    },

    addItem: function (id) {
        return this.cartRequest(PROJ.cartUrl('cart/add.js'), { id: id, quantity: 1 });
    },

    addItemAndCheckout: function (variantId, shippingProtectionProductId, addAndCheckoutElement) {
        var vid = String(variantId);
        var _this = this;
        fetch(PROJ.cartUrl('cart.js'))
            .then(function (r) {
                return r.json();
            })
            .then(function (cart) {
                var removeUpdates = {};
                if (shippingProtectionProductId) {
                    var pid = String(shippingProtectionProductId);
                    cart.items.forEach(function (item) {
                        if (String(item.product_id) === pid) {
                            removeUpdates[item.key] = 0;
                        }
                    });
                } else {
                    cart.items.forEach(function (item) {
                        if (String(item.variant_id) === vid) {
                            removeUpdates[item.key] = 0;
                        }
                    });
                }
                var chain = Promise.resolve();
                if (Object.keys(removeUpdates).length) {
                    chain = fetch(PROJ.cartUrl('cart/update.js'), {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ updates: removeUpdates }),
                    }).then(function (res) {
                        if (!res.ok) {
                            throw new Error('Network response was not ok');
                        }
                    });
                }
                return chain.then(function () {
                    return fetch(PROJ.cartUrl('cart/add.js'), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: 'quantity=1&id=' + encodeURIComponent(vid),
                    });
                });
            })
            .then(function (response) {
                if (!response || !response.ok) {
                    throw new Error('Network response was not ok');
                }
                window.location.href = '/checkout';
            })
            .catch(function (error) {
                console.error('Error adding item to cart:', error);
                _this.VAR.addAndCheckoutInProgress = false;
                if (addAndCheckoutElement) {
                    addAndCheckoutElement.classList.remove('is-processing');
                    addAndCheckoutElement.removeAttribute('aria-disabled');
                    addAndCheckoutElement.removeAttribute('tabindex');
                    addAndCheckoutElement.style.pointerEvents = '';
                }
                window.location.href = '/checkout';
            });
    },

    initCountdown: function() {
        var _this = this;
        var countdownElement = document.querySelector('.mini-cart-countdown');

        // Only run if countdown element exists
        if (!countdownElement) {
            return;
        }

        var countdownDate = countdownElement.getAttribute('data-countdown-date');
        var countdownTime = countdownElement.getAttribute('data-countdown-time') || '23:59';

        if (!countdownDate) {
            return;
        }

        // Parse date and time
        var dateParts = countdownDate.split('-');
        var timeParts = countdownTime.split(':');
        var endDate = new Date(
            parseInt(dateParts[0], 10), // year
            parseInt(dateParts[1], 10) - 1, // month (0-indexed)
            parseInt(dateParts[2], 10), // day
            parseInt(timeParts[0], 10) || 23, // hours
            parseInt(timeParts[1], 10) || 59, // minutes
            59 // seconds
        );

        function updateCountdown() {
            var now = new Date().getTime();
            var distance = endDate.getTime() - now;

            if (distance < 0) {
                // Countdown expired
                countdownElement.style.display = 'none';
                return;
            }

            // Calculate time units
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Update DOM elements
            var daysEl = countdownElement.querySelector('[data-days]');
            var hoursEl = countdownElement.querySelector('[data-hours]');
            var minutesEl = countdownElement.querySelector('[data-minutes]');
            var secondsEl = countdownElement.querySelector('[data-seconds]');

            if (daysEl) daysEl.textContent = String(days);
            if (hoursEl) hoursEl.textContent = String(hours);
            if (minutesEl) minutesEl.textContent = String(minutes);
            if (secondsEl) secondsEl.textContent = String(seconds);
        }

        // Initial update
        updateCountdown();

        // Update every second
        var countdownInterval = setInterval(function() {
            updateCountdown();
            // Check if countdown expired
            var now = new Date().getTime();
            if (endDate.getTime() - now < 0) {
                clearInterval(countdownInterval);
            }
        }, 1000);
    }
};
